import Link from "next/link"
import { Container } from "./components/Container"
import { Logo } from "../ui/Logo"

export function Footer() {
  return (
    <footer className="border-t border-gray-800 bg-gray-950">
      <Container>
        <div className="grid gap-8 py-12 sm:grid-cols-2 lg:grid-cols-3">
          <div className="sm:col-span-2 lg:col-span-1">
            <Logo variant="wordmark" />
            <p className="mt-4 max-w-xs text-sm text-gray-400">
              Open-source CLI for instant database reset. Supports PostgreSQL
              and MySQL. Built for reliable testing workflows.
            </p>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-gray-400">
              Product
            </p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link
                  href="/#features"
                  className="text-gray-400 transition-colors hover:text-gray-200"
                >
                  Features
                </Link>
              </li>
              <li>
                <Link
                  href="/docs"
                  className="text-gray-400 transition-colors hover:text-gray-200"
                >
                  Documentation
                </Link>
              </li>
              <li>
                <Link
                  href="/blog"
                  className="text-gray-400 transition-colors hover:text-gray-200"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  href="/#pricing"
                  className="text-gray-400 transition-colors hover:text-gray-200"
                >
                  Pricing
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-gray-400">
              Legal
            </p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link
                  href="/the-specified-commercial-transactions-act"
                  className="text-gray-400 transition-colors hover:text-gray-200"
                >
                  Commercial Transactions Act
                </Link>
              </li>
              <li>
                <Link
                  href="/contact"
                  className="text-gray-400 transition-colors hover:text-gray-200"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 py-8">
          <p className="text-center text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Seedmancer. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>
  )
}
